const getDatapointAndRemaining = (dimension, datapoints) => {
    const result = { dimDp: undefined, remaining: [] };
    for (const dp of datapoints ?? []) {
        if (dp.name === dimension) {
            result.dimDp = dp;
        }
        else {
            result.remaining.push(dp);
        }
    }
    return result;
};
const mapVisitablesByDimension = (visitables, dimension) => {
    const map = new Map();
    for (const visitable of visitables) {
        for (const series of visitable?.series ?? []) {
            const { dimDp, remaining } = getDatapointAndRemaining(dimension, series.datapoints);
            if (dimDp) {
                const dimValue = dimDp.value;
                if (!map.has(dimValue)) {
                    map.set(dimValue, []);
                }
                map.get(dimValue)?.push(...remaining);
            }
        }
    }
    return map;
};
const mergeVisitablesByDimension = (visitables, dimension) => {
    const baseSeries = visitables[0].series?.map((series) => ({ ...series })) || [];
    const map = mapVisitablesByDimension(visitables.slice(1), dimension);
    for (const series of baseSeries) {
        const dimDp = series.datapoints?.find((dp) => dp.name === dimension);
        if (dimDp) {
            const datapoints = map.get(dimDp.value) || [];
            series.datapoints = [...series.datapoints ?? [], ...datapoints];
        }
    }
    visitables[0] = { ...visitables[0], series: baseSeries };
};
export const insertDatapointsFromDifferentRequestVisitor = () => (args) => {
    const visitables = [...args.visitable].sort((a, b) => ((a?.id || 1) > (b?.id || 0) ? 1 : -1));
    const { arguments: argsList } = args.context.config?.[0] || {};
    if (argsList) {
        mergeVisitablesByDimension(visitables, argsList[0]);
    }
    args.visitable = [visitables?.[0]];
};
